// extracted by mini-css-extract-plugin
module.exports = {"GamesPage":"GamesPage_GamesPage__2IWR3","description":"GamesPage_description__Z4VTn","title":"GamesPage_title__1VC6l","card":"GamesPage_card__1P-WI"};